export const messages = {
  title: { id: 'admin/promotions.form.conditions.bin.title' },
  subtitle: { id: 'admin/promotions.form.conditions.bin.subtitle' },
  viewTitle: { id: 'admin/promotions.form.conditions.bin.view.title' },
  binField: {
    label: { id: 'admin/promotions.form.conditions.bin.field.title' },
    helpText: { id: 'admin/promotions.form.conditions.bin.field.help-text' },
  },
  validation: {
    invalidLength: {
      id: 'admin/promotions.form.conditions.bin.field.invalid-length',
    },
    invalidDigit: {
      id: 'admin/promotions.form.conditions.bin.field.invalid-digit',
    },
  },
  fileInput: {
    label: { id: 'admin/promotions.form.conditions.bin.input.file.label' },
    helpText: {
      id: 'admin/promotions.form.conditions.bin.input.file.help-text',
    },
    validation: {
      invalidEntries: {
        id: 'admin/promotions.form.conditions.bin.input.file.invalid-entries',
      },
      allInvalidEntries: {
        id: 'admin/promotions.form.conditions.bin.input.file.all-invalid-entries',
      },
      genericError: {
        id: 'admin/promotions.form.conditions.bin.input.file.generic-error',
      },
      wrongFormat: {
        id: 'admin/promotions.form.conditions.bin.input.file.wrong-format',
      },
      maxSize: {
        id: 'admin/promotions.form.conditions.bin.input.file.max-size',
      },
    },
  },
}
